<div class="container">
  <ppl-icon class="icon"
            svgIcon="warning-orange-full"
            height="16px"
            width="16px"></ppl-icon>
  <div class="message">{{ message }}</div>
  <div class="actions">
    <button pplButton
            pplButton1
            pplButtonSmall="xxs"
            (click)="onRefresh()"
            i18n="@@Refresh">Refresh</button>
    <button class="close-button"
            (click)="onClose()">
      <ppl-icon svgIcon="closering-red2"
                width="18px"
                height="18px"></ppl-icon>
    </button>
  </div>
</div>